<template>
  <div>
    <img v-if="pc" :src="$t('publications.img')" width="100%" />
    <img v-else :src="$t('publications.imgm')" width="100%" />
    <div v-if="!pc" style="position: fixed;z-index: 9">
      <div v-show="!mf" style="margin-left: -5px;color: #7f1f20;font-size: 30px" @click="mf = !mf">
        <a-icon type="caret-right" />
      </div>
      <div v-show="mf" style="margin-left: -20px">
        <div class="navigation_m" style="width: 265px">
          <div @click="mf = !mf" style="font-size: 30px">
            <a-icon type="caret-left" />
          </div>
          <div :class="{active_m : id === $t('publications.countryFacts.id')}"
               @click="query($t('publications.countryFacts.id'), 'countryFacts')">
            <span>{{$t('publications.countryFacts.name')}}</span>
          </div>
          <div :class="{active_m : id === $t('publications.researchPapers.id')}"
               @click="query($t('publications.researchPapers.id'), 'researchPapers')">
            <span>{{$t('publications.researchPapers.name')}}</span>
          </div>
          <div :class="{active_m : id === $t('publications.projectBrochures.id')}"
               @click="query($t('publications.projectBrochures.id'), 'projectBrochures')">
            <span>{{$t('publications.projectBrochures.name')}}</span>
          </div>
          <div :class="{active_m : id === $t('publications.companyBrochures.id')}"
               @click="query($t('publications.companyBrochures.id'), 'companyBrochures')">
            <span>{{$t('publications.companyBrochures.name')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('menu.publications')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="$t('publications.p')"></p>
      </div>
      <a-affix v-if="pc" :offset="50">
        <div class="navigation">
          <div :class="{active : id === $t('publications.countryFacts.id')}"
               @click="query($t('publications.countryFacts.id'), 'countryFacts')">
            <span>{{$t('publications.countryFacts.name')}}</span>
          </div>
          <div :class="{active : id === $t('publications.researchPapers.id')}"
               @click="query($t('publications.researchPapers.id'), 'researchPapers')">
            <span>{{$t('publications.researchPapers.name')}}</span>
          </div>
          <div :class="{active : id === $t('publications.projectBrochures.id')}"
               @click="query($t('publications.projectBrochures.id'), 'projectBrochures')">
            <span>{{$t('publications.projectBrochures.name')}}</span>
          </div>
          <div :class="{active : id === $t('publications.companyBrochures.id')}"
               @click="query($t('publications.companyBrochures.id'), 'companyBrochures')">
            <span>{{$t('publications.companyBrochures.name')}}</span>
          </div>
        </div>
        <img src="@/assets/top.png" alt="top" style="margin-left: 125px;cursor: pointer;position: absolute;margin-top: 500px" @click="toTop" />
      </a-affix>
      <div :style="{marginLeft: pc?'235px':'0'}">
        <div :style="{fontSize: pc?'22px':'26px'}" style="color: #7F1F20">{{$t(`publications.${key}.name`)}}</div>
        <div v-if="$t(`publications.${key}`).p"
             :style="{fontSize: pc?'18px':'20px', lineHeight: pc?'24px':'30px'}"
             style="font-family: MonotypeCorsiva,楷体, Arial, serif;color: #595959">
          {{$t(`publications.${key}.p`)}}
        </div>
        <a-divider v-else style="margin-top: 5px;background: #00023d" />
        <div class="publications_list">
          <div v-for="(item, index) in list" :key="index" @click="pdf(item)" style="cursor: pointer" :style="{width: pc?'17%':'30%'}">
            <img :src="`/acnImg/publications/${item.id}/Cover2.jpg`" width="100%" />
              <div style="margin: 10px 0 5px 0;line-height: 1.2">
                <img v-if="key === 'countryFacts'" :src="`/acnImg/publications/${item.id}/Flag.gif`" width="26" height="18" style="margin-right: 5px" />
                <span :class="{f20: !pc}" :style="{lineHeight: pc?'1.3':'24px'}" style="font-size: 16px" v-html="isEn ? item.ename : item.cname"></span>
              </div>
              <span :class="{f18: !pc}" class="hover_red" style="color: #a6a6a6;font-style: italic;border-bottom: 1px #a6a6a6 solid">
                {{item.hasPdf ? (isEn ? 'Free' : '免费下载') : (item.userOnly ? (isEn ? 'Coming Soon' : '即将发行') : (isEn ? 'Order Printed Copy' : '购买实体书'))}}
              </span>
          </div>
          <template v-if="pc">
            <div v-for="i in (5 - list.length % 5)" :key="-i" :style="{width: pc ? '17%' :'30%'}"></div>
          </template>
          <template v-else>
            <div v-for="i in (3 - list.length % 3)" :key="-i" :style="{width: pc ? '17%' : '30%'}"></div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="pc && key === 'countryFacts'" style="background: #f2f2f2;padding: 30px 0 50px 0">
      <div class="mw1200" style="padding-left: 235px">
        <div style="font-size: 20px;color: #00023d;border-bottom: 1px #00023d solid">{{$t('publications.videos')}}</div>
        <div style="display: flex;justify-content: space-between;margin: 25px 0">
            <div v-for="i in 3" :key="i" style="width: 30%">
              <template v-if="(page-1)*3+i-1 < vList.length">
                <video ref="video"
                       @mouseenter="mouseenter(i -1)" @mouseleave="mouseleave(i -1)"
                       :src="`/videos/${vList[(page-1)*3+i-1].id}/Video.mp4`"
                       :poster="`/videos/${vList[(page-1)*3+i-1].id}/poster.jpg`"
                       width="100%" style="object-fit:fill" height="190">
                </video>
                <div style="color: #7f1f20;line-height: 1.2;margin: 15px 0 5px 0">
                  {{isEn ? vList[(page-1)*3+i-1].ename : vList[(page-1)*3+i-1].cname}}
                </div>
                <div style="font-size: 14px;line-height: 1.2">
                  {{isEn ? vList[(page-1)*3+i-1].eprovider : vList[(page-1)*3+i-1].cprovider}}
                </div>
                <div>
                  {{vList[(page-1)*3+i-1].timeUpload}}
                  <template v-if="vList[(page-1)*3+i-1].audio">
                    | {{isEn ? 'Audio' : '音频'}}: {{getLanguage(vList[(page-1)*3+i-1].audio)}}
                  </template>
                  <template v-if="vList[(page-1)*3+i-1].subtitle">
                    | {{isEn ? 'Captions' : '字幕'}}: {{getLanguage(vList[(page-1)*3+i-1].subtitle)}}
                  </template>
                </div>
              </template>
            </div>
        </div>
        <a-pagination v-model="page" :total="vList.length" :pageSize="3" size="small" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'Publications',
  data () {
    return {
      id: '1',
      key: 'countryFacts',
      list: [],
      vList: [],
      page: 1,
      mf: false
    }
  },
  computed: {
    ...mapGetters(['isEn', 'pc'])
  },
  methods: {
    mouseenter (i) {
      this.$refs.video[i].controls = true
    },
    mouseleave (i) {
      this.$refs.video[i].controls = false
    },
    async query (id, key) {
      this.id = id
      this.key = key
      this.list = await request.get('/publication/list?type=' + id)
      this.toTop()
      this.mf = false
    },
    pdf (item) {
      if (item.hasPdf) {
        window.open(`/pdf/publications/${item.pdfName}.pdf`, '_blank')
      }
    },
    toTop () {
      window.scrollTo(0, 0)
    },
    getLanguage (language) {
      if (this.isEn) {
        return language === 'en' ? 'EN' : 'CH'
      } else {
        return language === 'en' ? '英语' : '中文'
      }
    }
  },
  mounted () {
    request.get(`/publication/list?type=${this.id}`).then(res => { this.list = res })
    request.get('/videos/list').then(res => { this.vList = res })
  }
}
</script>

<style lang="less">
  .publications_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 45px;
    > div {
      margin-bottom: 30px;
    }
  }
</style>
